module.exports = __webpack_public_path__ + "img/998f376.png";